import styled from 'styled-components'
import { devices } from '../../globalStyle'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 12px auto 0 auto;
`

export const ButtonImg = styled.img`
  margin-right: 0.5vw;
  height: 2.4vh;

  @media ${devices.smallDesktop} {
    margin-right: 10px;
    height: 16px;
  }

  @media ${devices.largeDesktop} {
    margin-right: 0.6vw;
    height: 1.6vh;
  }
`

export const ButtonText = styled.h2`
  color: #0090d3;
  margin-left: 0.5vw;
  margin-top: 0;
  margin-bottom: 0;
  font-family: 'Inter', sans-serif;
  font-size: 1.1vw;
  font-weight: bold;

  @media ${devices.smallDesktop} {
    margin-left: 8px;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 14px;
  }

  @media ${devices.largeDesktop} {
    font-size: 0.7vw;
  }
`

export const ButtonInner = styled.div`
  display: flex;
  align-items: center;
`

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5vw;

  svg {
    width: 1em;
    height: 1em;
    color: #0090d3;
    stroke: #0090d3 !important;
    fill: #0090d3 !important;
  }

  svg path {
    stroke: #0090d3 !important;
    fill: #0090d3 !important;
  }

  img {
    display: inline-block;
    height: 1.2em !important;
    width: auto !important;
  }

  @media ${devices.smallDesktop} {
    margin-right: 10px;
  }
`

export const ButtonPill = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border: 2px #0090d3 solid;
  border-radius: 24px;
  background-color: transparent;
  cursor: pointer;
  user-select: none;
  transition: background-color 120ms ease, opacity 120ms ease;
  font: inherit;
  color: inherit;
  outline: none;

  &:hover:not(:disabled) {
    background-color: #f2f2f2;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }

  @media ${devices.smallDesktop} {
    padding: 10px 20px;
    border-radius: 20px;
  }

  @media ${devices.largeDesktop} {
    padding: 8px 14px;
  }
`

export const CountText = styled.div`
  margin-top: 8px;
  color: #666;
  font-size: 14px;
  text-align: center;
  padding: 0 8px 10px 8px;
`
